import { CommonAPI } from "../Client";
import { appendProcessedFiles } from "../../../utils/imageUploadProcessor";

const getWebsiteProductPayload = (payload = {}) => {
  if (payload?.dto) return payload.dto;

  const { websiteId, id, uploadId, ...websiteProductPayload } = payload;
  return websiteProductPayload;
};

export const getWebsiteProductApi = async (payload = {}) => {
  try {
    const websiteId = payload?.websiteId ?? payload;
    const response = await CommonAPI.get(
      `/website/product?websiteId=${websiteId || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getAllWebsiteProductApi = async () => {
  try {
    const response = await CommonAPI.get("/website/all/product");
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postWebsiteProductApi = async (payload = {}) => {
  try {
    const response = await CommonAPI.post(
      `/website/product?websiteId=${payload?.websiteId || ""}`,
      getWebsiteProductPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateWebsiteProductApi = async (payload = {}) => {
  try {
    const response = await CommonAPI.put(
      "/website/product",
      getWebsiteProductPayload(payload),
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteWebsiteProductApi = async (payload = {}) => {
  try {
    const id = payload?.id ?? payload;
    const response = await CommonAPI.delete(`/website/product?id=${id || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const postWebsiteProductFilesApi = async (payload = {}) => {
  try {
    const formData = new FormData();

    await appendProcessedFiles(formData, "files", payload?.files || []);

    const response = await CommonAPI.post(
      "/website/product/upload/files",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteWebsiteProductFileApi = async (payload = {}) => {
  try {
    const uploadId = payload?.uploadId ?? payload;
    const response = await CommonAPI.delete(
      `/website/product/file?uploadId=${uploadId || ""}`,
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
